document.addEventListener('DOMContentLoaded', function () {
  const handleClick = (dropdownItem, dropdowns) => {
    const isOpen = dropdownItem.classList.contains('NavMenu--show-item');
    const searchBox = document.querySelector('.SiteHeader--root');
    const menuLabel = dropdownItem.querySelector('.NavMenu--menu-label');

    dropdowns.forEach((item) => {
      const menuLabel = item.querySelector('.NavMenu--menu-label');

      if (item !== dropdownItem) {
        item.classList.remove('NavMenu--show-item');
        menuLabel.setAttribute('aria-label', `${menuLabel.textContent.trim()}, see more`);
        menuLabel.setAttribute('aria-expanded', 'false');
      }
    });

    dropdownItem.classList.toggle('NavMenu--show-item', !isOpen);

    if (!isOpen) {
      menuLabel.setAttribute('aria-label', `${menuLabel.textContent.trim()}, hide`);
      menuLabel.setAttribute('aria-expanded', 'true');
    } else {
      menuLabel.setAttribute('aria-label', `${menuLabel.textContent.trim()}, see more`);
      menuLabel.setAttribute('aria-expanded', 'false');
    }
    searchBox.classList.remove('SiteHeader--search-is-open');
  };

  const dropdowns = document.querySelectorAll('.NavMenu--item');
  dropdowns.forEach((dropdownItem) => {
    dropdownItem.addEventListener('click', function (event) {
      handleClick(this, dropdowns);
      event.stopPropagation();
    });
  });

  const handleClickOutside = (event) => {
    if (!event.target.closest('.NavMenu--item')) {
      dropdowns.forEach((item) => {
        const menuLabel = item.querySelector('.NavMenu--menu-label');

        item.classList.remove('NavMenu--show-item');
        menuLabel.setAttribute('aria-label', `${menuLabel.textContent.trim()}, see more`);
        menuLabel.setAttribute('aria-expanded', 'false');
      });
    }
  };

  const handleNavAnalyticsClick = (event) => {
    const element = event.target;
    const isNavLink = element.classList.contains('NavMenu--submenu-link');
    const isLogoImage =
      element.hasAttribute('alt') && element.parentElement.classList.contains('MainHeader--logo-container');
    let clickedContent = '';

    if (isNavLink) {
      clickedContent = element.textContent || '';
    } else if (isLogoImage) {
      clickedContent = element.getAttribute('alt') || '';
    }

    if (clickedContent !== '' && window.ltanalytics) {
      window.ltanalytics.push([
        'track',
        'Navigation Click',
        {
          clicked_content: clickedContent,
        },
      ]);
    }
  };

  window.addEventListener('click', handleClickOutside);

  document.querySelectorAll('.NavMenu--submenu-item .NavMenu--submenu-link').forEach((el) => {
    el.addEventListener('click', handleNavAnalyticsClick);
  });

  document.querySelector('.MainHeader--logo-image').addEventListener('click', handleNavAnalyticsClick);
});
